import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import * as moment from 'moment-timezone';

@Injectable()
export class DateService {
  constructor() {}

  DATA_WITHOUT_SEPARATORS_LENGTH = 8;

  private formatDate(date: string): moment {
    const isValidISODate = Date.parse(date);

    if (isValidISODate) {
      return moment(date);
    }

    return date.length === this.DATA_WITHOUT_SEPARATORS_LENGTH ? moment(date, 'DDMMYYYY') : moment(date, 'DD/MM/YYYY');
  }

  isValid(date: Moment | Date | String | Object): boolean {
    let isoDate = date;
    if (typeof date === 'string') {
      isoDate = this.formatDate(date);
    }

    const m = moment(isoDate, 'DD/MM/YYYY').utc() as Moment;
    return m.isValid() && m.format() !== 'Invalid date' && m.year() > 1900;
  }

  isFuture(date: Moment | Date | String | Object): boolean {
    let isoDate = date;
    if (typeof date === 'string') {
      isoDate = this.formatDate(date);
    }

    const m = moment(isoDate).utc().locale('pt-br') as Moment;
    return m.isAfter(moment().utc().locale('pt-br').toDate());
  }
}
